import React, { useState, useEffect } from 'react';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Always true, cannot be disabled
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const consent = localStorage.getItem('ashud-cookie-consent');
    if (!consent) {
      setShowConsent(true);
    } else {
      const savedPreferences = JSON.parse(consent);
      setPreferences(savedPreferences);
      // Initialize analytics if consent was given
      if (savedPreferences.analytics) {
        initializeAnalytics();
      }
    }
  }, []);

  const initializeAnalytics = () => {
    // Initialize Google Analytics or other analytics tools here
    console.log('Analytics initialized');
    // Example: gtag('config', 'GA_MEASUREMENT_ID');
  };

  const handleAcceptAll = () => {
    const newPreferences = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    setPreferences(newPreferences);
    localStorage.setItem('ashud-cookie-consent', JSON.stringify(newPreferences));
    setShowConsent(false);
    initializeAnalytics();
  };

  const handleAcceptNecessary = () => {
    const newPreferences = {
      necessary: true,
      analytics: false,
      marketing: false
    };
    setPreferences(newPreferences);
    localStorage.setItem('ashud-cookie-consent', JSON.stringify(newPreferences));
    setShowConsent(false);
  };

  const acceptAll = () => {
    handleAcceptAll();
  };

  const rejectAll = () => {
    handleAcceptNecessary();
  };

  const savePreferences = () => {
    localStorage.setItem('ashud-cookie-consent', JSON.stringify(preferences));
    setShowConsent(false);
    setShowPreferences(false);
    if (preferences.analytics) {
      initializeAnalytics();
    }
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md z-50 animate-fade-in-up">
      <div className="bg-white rounded shadow-card-hover border border-line overflow-hidden">
        {/* Header */}
        <div className="px-6 py-5 border-b border-line">
          <h4 className="text-ink text-base font-bold">Gestion des cookies</h4>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-body text-sm leading-relaxed mb-6">
            Nous utilisons des cookies pour améliorer votre expérience sur notre site et analyser notre trafic.
            Vous pouvez choisir vos préférences ci-dessous.
          </p>

          {/* Preferences Toggle */}
          {showPreferences && (
            <div className="mb-6 space-y-3">
              <div className="bg-surface p-4 rounded border border-line">
                <label className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    checked={preferences.necessary}
                    disabled
                    className="mt-1 w-4 h-4 text-primary border-line rounded focus:ring-primary"
                  />
                  <div>
                    <span className="text-ink font-semibold text-sm">Cookies nécessaires</span>
                    <p className="text-muted text-xs mt-1">
                      Essentiels au fonctionnement du site (obligatoires)
                    </p>
                  </div>
                </label>
              </div>

              <div className="bg-surface p-4 rounded border border-line">
                <label className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    checked={preferences.analytics}
                    onChange={(e) => setPreferences({
                      ...preferences,
                      analytics: e.target.checked
                    })}
                    className="mt-1 w-4 h-4 text-primary border-line rounded focus:ring-primary"
                  />
                  <div>
                    <span className="text-ink font-semibold text-sm">Cookies d'analyse</span>
                    <p className="text-muted text-xs mt-1">
                      Nous aident à améliorer notre site web
                    </p>
                  </div>
                </label>
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="flex flex-col gap-2">
            <button
              onClick={acceptAll}
              className="w-full bg-primary text-white px-4 py-2.5 rounded font-semibold text-sm transition-colors duration-200 hover:bg-primary-dark"
            >
              Tout accepter
            </button>

            <div className="flex gap-2">
              <button
                onClick={() => setShowPreferences(!showPreferences)}
                className="flex-1 bg-white text-primary px-4 py-2 rounded font-medium text-sm border border-primary transition-colors duration-200 hover:bg-primary-light"
              >
                {showPreferences ? 'Masquer' : 'Personnaliser'}
              </button>

              <button
                onClick={rejectAll}
                className="flex-1 bg-white text-body px-4 py-2 rounded font-medium text-sm border border-line transition-colors duration-200 hover:bg-surface"
              >
                Refuser
              </button>
            </div>

            {showPreferences && (
              <button
                onClick={savePreferences}
                className="w-full bg-ink text-white px-4 py-2.5 rounded font-semibold text-sm transition-colors duration-200 hover:bg-ink/90 mt-2"
              >
                Sauvegarder mes préférences
              </button>
            )}
          </div>
        </div>

        {/* ASHUD Branding */}
        <div className="bg-surface px-6 py-3 border-t border-line">
          <p className="text-xs text-muted text-center">
            <span className="font-semibold text-primary">ASHUD Tchad</span> - Protection de vos données
          </p>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
